import { parseRuntime, ruleEngineRequest } from './impl-helper';

export const getAbtFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    const factInfo = current.node.data.factInfo;
    const eid = factInfo.props.eid || '';

    //没有eid的时候，直接返回false
    if (!eid) {
        return false;
    }

    //abt是一个特殊的fact，这个接口有写入的操作，所以需要对前置条件进行处理，检查是否满足条件
    const preConditions = params.preConditions || [];
    const preConditionResults = await Promise.all(
        preConditions.map(async (condition) => {
            //目前所有条件都equal true
            return await almanac.factValue(condition.fact, condition.params);
        })
    );

    console.log('[fego-condition][getAbtFactRender]preConditionResults', preConditions, preConditionResults);
    //如果有一个前置条件不满足，那么就直接返回false,不再继续执行发送请求
    if (preConditionResults.some((item) => !item)) {
        console.warn('[fego-condition][getAbtFactRender]preConditionResults not match');
        return false;
    }

    const { version } = await ruleEngineRequest(
        'abtest-container',
        'join',
        {
            eid
        },
        variable,
        {
            method: 'post',
            reqOpt: { group: null }
        }
    );

    return current.port.id === version;
};
